/* eslint-disable @typescript-eslint/naming-convention */
import { type SizeType } from 'antd/es/config-provider/SizeContext';
import colors from 'core/constants/colors';

const viewportWidth = window.innerWidth;

const ConfigStyle = {
  theme: {
    token: {
      fontFamily: `'Noto Sans', 'sans-serif'`,
      fontSize: 16,
      colorBgBase: colors.white,
      colorBgContainer: colors['neutral-10'],
      colorBorder: colors['neutral-60'],
      colorBgContainerDisabled: colors['neutral-40'],
      colorSuccess: colors['success-500'],
      colorError: colors['danger-500'],
      colorPrimary: colors['primary-700'],
      colorPrimaryHover: colors['primary-500'],
      colorTextDisabled: colors['neutral-100'],
      colorTextPlaceholder: colors['neutral-300'],
    },
    components: {
      Button: {
        borderRadius: 4,
        contentFontSize: 14,
        primaryShadow: 'none',
        defaultShadow: 'none',
      },
      Layout: {
        headerColor: colors.mutedBlack,
        bodyBg: colors.formColor,
      },
      Tooltip: {
        colorText: colors['neutral-500'],
        colorBgSpotlight: colors['neutral-800'],
      },
      Table: {
        colorTextHeading: colors.tableHeaderColor,
        headerBg: colors.tableHeadBg,
        cellFontSize: 14,
        rowHoverBg: colors.tableHoverBg,
        borderColor: colors.tableBorder,
        borderRadius: 58,
        padding: 10,
      },
      ...(viewportWidth > 900 && {
        Menu: {
          subMenuItemBg: colors.white,
          itemSelectedColor: colors.white,
          itemSelectedBg: colors['primary-500'],
          itemBg: colors.mutedPrimary,
          itemColor: colors.titleColor,
          itemHoverColor: colors['neutral-500'],
          itemHoverBg: colors['primary-50'],
          itemActiveBg: colors['primary-500'],
        },
      }),
      Input: {
        activeBorderColor: colors['primary-500'],
        colorText: colors['neutral-800'],
        colorBorderSuccess: colors['success-500'],
      },
      Checkbox: {
        colorPrimary: colors.primary,
      },
      Select: {
        selectorBg: colors['neutral-20'],
        colorBorder: colors.selectBorder,
        optionSelectedFontWeight: 400,
        colorBgElevated: colors.white,
        optionSelectedBg: colors.white,
        optionSelectedColor: colors['primary-500'],
        optionSelectedBorderColor: colors['primary-100'],
        optionActiveBg: colors['primary-50'],
        optionFontSize: 16,
      },
      DatePicker: {
        colorText: colors['neutral-300'],
        colorTextDisabled: colors['neutral-80'],
        colorPrimary: colors['primary-300'],
      },
      Typography: {
        colorTextHeading: colors.menuTitleColor,
      },
      Tree: {},
      Segmented: {
        itemSelectedBg: colors['primary-700'],
        itemSelectedColor: colors.white,
        trackBg: colors.subheading,
      },
    },
  },

  componentSize: 'large' as SizeType,
  labelfontWeight: '500',
  labelColor: colors['neutral-700'],
  labelfontSize: '14px',
  colors,
  contentProps: {
    className: 'custom-form',
    bordered: false,
  },
};

export default ConfigStyle;
